import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { of } from 'rxjs';
import { FeedActionTypes } from '@core/store/actions/feed.actions';
import * as feedActions from '@core/store/actions/feed.actions';
// import { SxFeedService } from '@services';
import { FeedService } from '../services/feed.service';

@Injectable()
export class FeedEffects {
  // constructor(private feedService: SxFeedService, private actions$: Actions) {}
   constructor(private feedService: FeedService, private actions$: Actions) {}

  loadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FeedActionTypes.LoadFeedData),
      exhaustMap(action => {
        return this.feedService.getNewsFeed().pipe(
          map(feedItems => new feedActions.LoadFeedSuccess(feedItems)),
          catchError(error => of(new feedActions.LoadFeedFail(error)))
        );
      })
    );
  });
}
